module.exports = __webpack_public_path__ + "static/img/school1.06ddff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/school1.png
// module id = IU/X
// module chunks = 1